import { inject, NgModule, Signal } from '@angular/core';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { IsEnableOpenTelemetry } from './open-telemetry.exp';
import { PerformanceMetricsBootstrapService } from './performance-metrics/performance-metrics-bootstrap.service';
import { isOpenTelemetryEnvEnabled } from './open-telemetry.service';

@NgModule()
export class OpenTelemetryBootstrapModule {
  private isEnableOpenTelemetry: Signal<boolean> = IsEnableOpenTelemetry();
  private performanceMetricsBootstrapService: PerformanceMetricsBootstrapService = inject(
    PerformanceMetricsBootstrapService
  );

  constructor(private browserApi: BrowserApiSupportService) {
    if (isOpenTelemetryEnvEnabled(this.browserApi) && this.isEnableOpenTelemetry()) {
      this.performanceMetricsBootstrapService.init();
    }
  }
}
